/* Inline header search.

   The icon stays a real link to /search so the feature works without
   JavaScript; this intercepts the click and opens a panel instead.

   Suggestions come from Shopify's own predictive endpoint, so results match
   what the search page would return rather than a separate index. */
(function () {
  var panel = document.querySelector('[data-search-panel]');
  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');
  if (!panel || !input) return;

  var timer = null;
  var lastQuery = '';

  function open() {
    panel.hidden = false;
    /* Reveal after the frame that unhides it, or the transition has nothing to
       animate from and the panel simply appears. */
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      input.focus();
    });
    document.querySelectorAll('[data-search-toggle]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
    var menu = document.getElementById('bb-menu');
    if (menu) menu.removeAttribute('open');
  }

  function close() {
    panel.classList.remove('is-open');
    document.querySelectorAll('[data-search-toggle]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 200);
  }

  /* suggest.json returns the amount without a currency symbol, so wrap it in
     the shop's own money format rather than assuming a dollar sign. */
  function formatPrice(value) {
    if (!value) return '';
    var body = document.querySelector('[data-money-format]');
    var fmt = (body && body.dataset.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }

  function render(items, query) {
    if (!items.length) {
      results.innerHTML = '<p class="search-panel__empty">No matches for &ldquo;' + esc(query) + '&rdquo;</p>';
      return;
    }
    results.innerHTML = '<ul class="search-panel__list">' + items.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy" width="120" height="120">'
        : '<span class="search-panel__noimg"></span>';
      return '<li><a href="' + p.url + '">' + img +
        '<span class="search-panel__meta"><span class="search-panel__title">' + esc(p.title) + '</span>' +
        '<span class="search-panel__price">' + esc(formatPrice(p.price)) + '</span></span></a></li>';
    }).join('') + '</ul>';
  }

  function search(q) {
    if (q.length < 2) { results.innerHTML = ''; return; }
    if (q === lastQuery) return;
    lastQuery = q;
    var url = window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d.resources && d.resources.results && d.resources.results.products) || [];
        render(items.map(function (p) {
          return { title: p.title, url: p.url, featured_image: p.featured_image, price: p.price };
        }), q);
      })
      .catch(function (e) { console.error('[bb-search]', e); });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (toggle) {
      e.preventDefault();
      if (panel.classList.contains('is-open')) close(); else open();
      return;
    }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }
    if (panel.classList.contains('is-open') && !e.target.closest('[data-search-panel]')) close();
  });

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    /* Debounced: typing a word should not fire a request per keystroke. */
    timer = setTimeout(function () { search(q); }, 220);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
  });
})();
